import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import themeConfig from './theme.config';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import { SUPPORTED_LANGUAGE_CODES } from './global/languages';

// RTL languages list
const RTL_LANGUAGES = ['ae', 'ar', 'he', 'fa', 'ur'];

i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        supportedLngs: SUPPORTED_LANGUAGE_CODES,
        fallbackLng: themeConfig.locale || 'en',
        keySeparator: '.',
        nsSeparator: ':',
        debug: false,
        load: 'languageOnly',
        ignoreJSONStructure: false,
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage'],
        },
        ns: ['translation', 'categories', 'account_types'],
        defaultNS: 'translation',
    });

// Add RTL detection and direction switching
i18n.on('languageChanged', (lng) => {
    dayjs.locale(lng);
    const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lng);
});

// Set initial direction and locale
const currentLang = i18n.language || themeConfig.locale || 'en';
dayjs.locale(currentLang);
const initialDir = RTL_LANGUAGES.includes(currentLang) ? 'rtl' : 'ltr';
document.documentElement.setAttribute('dir', initialDir);
document.documentElement.setAttribute('lang', currentLang);

export default i18n;
